<div class="container mt-3">
  <div class="d-flex flex-column">
    <div class="d-flex flex-row">
      <strong class="col-2">Report Id: </strong>
      <div class="offset-md-1 mb-1">{{ data ? 'RPT' + data?.id : '' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Folder Id: </strong>
      <div class="offset-md-1 mb-1">{{ data ? 'SRT' + data.structureId : '' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Name: </strong>
      <div class="offset-md-1 mb-1">{{ data?.name }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Favorite: </strong>
      <div *ngIf="data?.favorite" class="offset-md-1 mb-1">
        <span class="mr-1">Yes</span>
        <mat-icon fontSet="fas" fontIcon="fa-star" color="accent" class="mr-1 h-auto"></mat-icon>
      </div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Source: </strong>
      <div class="offset-md-1 mb-1">No</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Status: </strong>
      <div class="offset-md-1 mb-1 w-100">
        <ns-status *ngIf="data?.status" [status]="data && data.status ? data.status.toLowerCase() : 'inactive'" class="w-25"></ns-status>
      </div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Threshold: </strong>
      <div class="offset-md-1 mb-1">{{ data && data.tabs.length > 0 ? data.tabs[0].threshold : '' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Multi tab: </strong>
      <div class="offset-md-1 mb-1">{{ data ? data.tabs.length > 1 ? 'Yes' : 'No' : '' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Attachment: </strong>
      <div class="offset-md-1 mb-1">{{ data ? (data?.attachmentType === attachmentTypes.SINGLE_FILE ? 'Single File' : 'Multiple File') : '' }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Owner: </strong>
      <div class="offset-md-1 mb-1">{{ data?.owner }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Created by: </strong>
      <div class="offset-md-1 mb-1">{{ data?.createdBy }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Created date: </strong>
      <div class="offset-md-1 mb-1"></div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Updated by: </strong>
      <div class="offset-md-1 mb-1">{{ data?.updatedBy }}</div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Updated date: </strong>
      <div class="offset-md-1 mb-1"></div>
    </div>
    <div class="d-flex flex-row">
      <strong class="col-2">Last Execution: </strong>
      <div class="offset-md-1 mb-1">
        {{ data && data.historyExecutions.length > 0 ? (data.historyExecutions[0].finalExecutionTime | date:'MM/dd/yyyy hh:mm a') : '' }}
      </div>
    </div>
  </div>
</div>
